import React, { useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentUpload = ({ 
  documents, 
  onDocumentUpload, 
  onDocumentRemove, 
  currentLanguage 
}) => {
  const licenseInputRef = useRef(null);
  const certificationInputRef = useRef(null);

  const content = {
    fr: {
      licenseTitle: 'Licence d\'agence',
      licenseDesc: 'Téléchargez votre licence officielle d\'agence de voyage',
      certificationTitle: 'Certifications (optionnel)',
      certificationDesc: 'Certifications professionnelles, accréditations Saudi, etc.',
      uploadButton: 'Choisir un fichier',
      changeButton: 'Changer',
      removeButton: 'Supprimer',
      fileFormats: 'PDF, JPG, PNG (Max 5MB)',
      uploaded: 'Téléchargé'
    },
    ar: {
      licenseTitle: 'ترخيص الوكالة',
      licenseDesc: 'قم بتحميل ترخيص وكالة السفر الرسمي الخاص بك',
      certificationTitle: 'الشهادات (اختياري)',
      certificationDesc: 'الشهادات المهنية، الاعتمادات السعودية، إلخ',
      uploadButton: 'اختر ملف',
      changeButton: 'تغيير',
      removeButton: 'حذف',
      fileFormats: 'PDF, JPG, PNG (حد أقصى 5 ميجابايت)',
      uploaded: 'تم التحميل'
    }
  };

  const text = content?.[currentLanguage];

  const handleFileChange = (event, type) => {
    const file = event?.target?.files?.[0];
    if (file) {
      if (file?.size > 5 * 1024 * 1024) {
        alert(currentLanguage === 'fr' ?'Le fichier est trop volumineux. Maximum 5MB.' :'الملف كبير جدًا. الحد الأقصى 5 ميجابايت.');
        return;
      }
      onDocumentUpload(type, file);
    }
  };

  const DocumentCard = ({ type, title, description, inputRef }) => {
    const document = documents?.[type];

    return (
      <div className="border-2 border-dashed border-border rounded-xl p-4 md:p-6 hover:border-primary/50 transition-smooth">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon 
              name={document ? 'FileCheck' : 'Upload'} 
              size={24} 
              className={document ? 'text-success' : 'text-primary'} 
            />
          </div>

          <div className="flex-1 min-w-0">
            <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
              {title}
            </h4>
            <p className="caption text-muted-foreground mb-3">
              {description}
            </p>

            {document ? (
              <div className="space-y-3">
                <div className="flex items-center gap-2 p-3 bg-success/10 rounded-lg">
                  <Icon name="FileText" size={18} className="text-success flex-shrink-0" />
                  <span className="text-sm text-foreground truncate flex-1">
                    {document?.name}
                  </span>
                  <span className="caption text-success flex-shrink-0">
                    {text?.uploaded}
                  </span>
                </div>

                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => inputRef?.current?.click()}
                    iconName="RefreshCw"
                    iconPosition="left"
                  >
                    {text?.changeButton}
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => onDocumentRemove(type)}
                    iconName="Trash2"
                    iconPosition="left"
                  >
                    {text?.removeButton}
                  </Button>
                </div>
              </div>
            ) : (
              <div className="space-y-2">
                <Button
                  variant="outline"
                  onClick={() => inputRef?.current?.click()}
                  iconName="Upload"
                  iconPosition="left"
                >
                  {text?.uploadButton}
                </Button>
                <p className="caption text-muted-foreground">
                  {text?.fileFormats}
                </p>
              </div>
            )}

            <input
              ref={inputRef}
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => handleFileChange(e, type)}
              className="hidden"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <DocumentCard
        type="license"
        title={text?.licenseTitle}
        description={text?.licenseDesc}
        inputRef={licenseInputRef}
      />
      <DocumentCard
        type="certification"
        title={text?.certificationTitle}
        description={text?.certificationDesc}
        inputRef={certificationInputRef}
      />
    </div>
  );
};

export default DocumentUpload;